export enum AuthorityCostCenter {
  REGISTER_COST_CENTER_EDIT = '1.19.4',
  REGISTER_COST_CENTER_DELETE = '1.19.3',
  REGISTER_COST_CENTER_ADD = '1.19.2',
  REGISTER_COST_CENTER_VIEW = '1.19.1',
  REGISTER_COST_CENTER_REGISTRATION = '1.19',
}
